import './style.scss'
import { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import ApiContext from 'src/provider/API/call-service';
import { 
    AbsoluteContainer, AppSpan, Button, CustomContainer, FlexRow, 
    GridContainer, ScreenContainer, ScreenTitle 
} from "src/style"
import utility from "src/utils/utility"
import { IoIosArrowBack } from "react-icons/io";
import { Customer } from 'src/model';
import { CustomerInfo, LocationHistory } from 'src/component';

const CustomerDetails: React.FC<any> = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {selectedCustomer}} = useContext(AppInfoContext)
    const [customer, setCustomer] = useState<Customer>(selectedCustomer)
    const [navPosition, setNavPosition] = useState(0)

    const isAddressVerified = customer?.verificationStatus === 'VERIFIED'

    useEffect(() => {
        if (selectedCustomer?.id) setCustomer(selectedCustomer)
    }, [selectedCustomer])

    async function handleVerifyUser () {
        const response = await API.verifyAddress(customer?.id)
        if (response) {
            navigate(-1)
        }
    }

    return (
        <ScreenContainer padding='2.5'>
            <FlexRow 
                gap="2" width="auto" 
                sizeUnit="" bottomMargin='4'
            >
                <GridContainer 
                    width="4" height="4" 
                    borderColor="#5627FF"
                    radius="0.4"
                    onClick={() => navigate(-1)}
                >
                    <IoIosArrowBack color="#5627FF" fontSize='2.5rem' />
                </GridContainer>
                <CustomContainer 
                    height="4.9" 
                    width="0.1" 
                    borderColor="#E0E0E0" 
                />
                <CustomContainer width="auto" sizeUnit="">
                    <ScreenTitle 
                        color='#333333' 
                        textSize='2.4' 
                        fontWeight='700'
                    >
                        Customer Details
                    </ScreenTitle>
                    <AppSpan color="#333333">Customer &gt; Customer Details</AppSpan>
                </CustomContainer>
            </FlexRow>

            <FlexRow 
                justifyContent='space-between' wrap='wrap' gap='3' bottomMargin='3'
            >
                <GridContainer
                    className='scrollable-container toggle-border-bottom'
                    height="3.6" width='31'
                >
                    <AbsoluteContainer 
                        width={navPosition === 0 ? '14' : '14'} 
                        top="0" left={`${navPosition}`}
                    >
                        <CustomContainer 
                            bgColor="#F0ECFF" height="3.6" 
                            borderBottomColor='#5627FF' borderWidth='4.5'
                        />
                    </AbsoluteContainer>
                    <FlexRow
                        alignItems='flex-start'
                        gap='1'
                        style={{zIndex: '2'}}
                    >
                        <GridContainer 
                            width='14' rightMargin='1.5' 
                            hoverBgColor={navPosition === 0 ? '' : '#F0ECFF'}
                            onClick={() => setNavPosition(0)}
                            className='toggled-item'
                        >
                            <AppSpan  
                                cursor="pointer"
                                fontWeight={navPosition === 0 ? "700" : "400"}
                                color={navPosition === 0 ? "#181D27" : "#828282"}
                            >
                                Customer Details
                            </AppSpan>
                        </GridContainer>
                        <GridContainer 
                            width='14' rightMargin='1.5'
                            hoverBgColor={navPosition === 16.5 ? '' : '#F0ECFF'}
                            onClick={() => setNavPosition(16.5)}
                            className='toggled-item'
                        >
                            <AppSpan 
                                cursor="pointer"
                                fontWeight={navPosition === 16.5 ? "700" : "400"}
                                color={navPosition === 16.5 ? "#181D27" : "#828282"}
                            >
                                Location History
                            </AppSpan>
                        </GridContainer>
                    </FlexRow>
                </GridContainer>

                { (!isAddressVerified && navPosition === 0) &&
                    <Button 
                        width='17' 
                        hoverBgColor='#ffffff' 
                        hoverColor='#5627FF'
                        borderColor='#5627FF'
                        onClick={handleVerifyUser}
                    >
                        Verify User
                    </Button>
                }
            </FlexRow>
            { navPosition === 0 ? 
                <CustomerInfo customer={customer} /> 
                :
                    <LocationHistory customerId={customer?.id} />
            }
        </ScreenContainer>
    )
}

export default utility.routeData('customers/customer-details', 'Customer Details', <CustomerDetails/>)